import React, {useEffect, useState} from 'react';
import _axios from "../../../httpService"
import {prefixUrl} from "../../../utils/utilsData";
import {toast} from "react-toastify";
import {calculateSumOfEachRow} from "../SellFactorFunctions";
import SelectProductStoreRoom from "../../Factor/SelectProductStoreRoom";

const AddProductSection = ({
                             sendData,
                             setSendData,
                             initialData,
                             componentData,
                             setComponentData,
                             isShowStoreRoom,
                             mode,
                             storeRoomType
                           }) => {


  const [isLoadingColorSize, setIsLoadingColorSize] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [select, setSelect] = useState('barcode');
  const [searchListArray, setSearchListArray] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [colorSizeArrayList, setColorSizeArrayList] = useState([])
  const [selectedColorSize, setSelectedColorSize] = useState('')


  let requestUrlByMode = "/clothingShopFactor"
  let url = "";
  url = prefixUrl() + requestUrlByMode + "/?request=productDetail&type=" + select + "&detail=" + searchTerm + "&option=" + selectedColorSize + "&storeId=" + componentData.currentStoreId
  // debugger
  if (mode === "remittance") {
    requestUrlByMode = "/storeRemittance"
    url = prefixUrl() + requestUrlByMode + "/?request=productDetail&type=" + select + "&detail=" + searchTerm + "&option=" + selectedColorSize + "&storeId=" + componentData.currentStoreId
  }

// selectType & factorId
  if (mode === 'saleReturn') {
    requestUrlByMode = "/returnFromSale"
    const returnFactorId = sendData.factorId
    url = prefixUrl() + requestUrlByMode + "/?request=productDetail&type=" + select + "&detail=" + searchTerm + "&option=" + selectedColorSize + "&storeId=" + componentData.currentStoreId + "&factorId=" + returnFactorId;
  }
  if (mode === 'buyReturn') {
    requestUrlByMode = "/returnFromBuy"
    const returnFactorId = sendData.factorId
    url = prefixUrl() + requestUrlByMode + "/?request=productDetail&type=" + select + "&detail=" + searchTerm +
      "&option=" + selectedColorSize + "&storeId=" + componentData.currentStoreId + "&factorId=" + returnFactorId;
  }


  useEffect(() => {

    // let url = prefixUrl() + "/clothingShopFactor/?request=productList&listType=" + select;

    if (mode === "saleReturn") {
      // من اینجا چک کنم اگه فاکتور تایپ برابر با فاکتور بود باید  مقدار فاکتور آیدی از آرلوکاپ رو بزارم در غیراینصورت
      // باید خالی بزارم

      if (sendData.factorId === "" || sendData.factorId === undefined) {
        // toast.error("لطفا یک فاکتور انتخاب کنید.")
        return
      }
      const factorId = sendData.factorId;

      url = prefixUrl() + "/returnFromSale/?request=productList&listType=" + select + "&factorId=" + factorId

    } else if (mode === 'buyReturn') {
      // من اینجا چک کنم اگه فاکتور تایپ برابر با فاکتور بود باید  مقدار فاکتور آیدی از آرلوکاپ رو بزارم در غیراینصورت
      // باید خالی بزارم

      if (sendData.factorId === "" || sendData.factorId === undefined) {
        // toast.error("لطفا یک فاکتور انتخاب کنید.")
        return
      }
      const factorId = sendData.factorId;

      /**
       اینجا استثنا باید کد انبار رو هم بفرستم
       */
      if (!componentData.currentStoreId) {
        return;
      }
      url = prefixUrl() + "/returnFromBuy/?request=productList&listType=" + select + "&factorId=" + factorId +
        "&storeId= " + componentData.currentStoreId;


    } else if (mode === "remittance") {
      if (!componentData.currentStoreId) {
        return;
      }
      url = prefixUrl() + requestUrlByMode + "/?request=productList&listType=" + select + "&storeId=" + componentData.currentStoreId
    } else if (mode === 'sell') {
      if (!componentData.currentStoreId) {
        return;
      }
      url = prefixUrl() + requestUrlByMode + "/?request=productList&listType=" + select + "&storeId=" + componentData.currentStoreId

    }

    setIsLoading(true)

    _axios.get(url).then(res => {
      const data = res.data;
      if (data.status) {
        // i want to Show productsArrayList  in search List
        // setComponentData({productsArrayList: data.data})
        setSearchListArray(data.data)
        setIsLoading(false)

      }
    })
    // تا این قسمت باز شد درخواست بزنه و اطلاعات رو بیاره بشونه
  }, [select, sendData.factorId, componentData.currentStoreId])

  const searchBoxChangeHandler = (e) => {

    const value = e.target.value
    setSearchTerm(value)

    if (select === 'name') {
      const isSearchTermInArrayList = searchListArray.filter(v => v === value)[0].length;
      // اگه کالا توی اون لیستی که از نام ها هست موجود نبود نیاز نیست چک کنی. پس همینجا برگرد در غیر اینصورت درخواست بده رنگ و سایز بیاد
      if (isSearchTermInArrayList === 0) {
        return
      }

      setIsLoadingColorSize(true)
      let requestUrl = prefixUrl() + requestUrlByMode + "/?request=colorSize&productName=" + value;
      if (mode === 'saleReturn') {
        requestUrl = prefixUrl() + requestUrlByMode + "/?request=colorSize&productName=" + value + "&factorId=" + sendData.factorId
      }
      if (mode === 'buyReturn') {
        requestUrl = prefixUrl() + requestUrlByMode + "/?request=colorSize&productName=" + value +
          "&factorId=" + sendData.factorId +
          "&storeId=" + componentData.currentStoreId;
      }
      /**
       در صورتی که درخواست توی حواله انبار باشه باید استور آیدی مبدا رو بزارم تا بهم  رنگ و سایز ها رو بده
       */
      if (mode === 'remittance') {
        debugger
        requestUrl = prefixUrl() + requestUrlByMode + "/?request=colorSize&productName=" + value + "&storeId=" + componentData.currentStoreId
      }
      _axios.get(requestUrl).then(res => {
        const data = res.data;

        setIsLoadingColorSize(false)
        if (data.status) {
          setColorSizeArrayList(data.data)
        } else {
          setColorSizeArrayList([])

          toast.error(data.message)
        }
      })

    }
    if (e.key === "Enter") addProductHandler();

  }
  const addNewRowToPriceTable = (inputObject) => {
    const objectData = {...inputObject}
    //I know That productId is Uniq that backEnd Send to Front

    let tableData = [];
    // i must add StoreId and Store Name From ComponentData
    /// mode === "saleReturn" i use this information
    objectData.storeId = componentData.currentStoreId
    objectData.storeName = componentData.currentStoreName


    if (mode === "remittance") {
      objectData.seriesId = "";
      if (componentData.destinationStoreId === undefined || componentData.destinationStoreName === undefined) {
        toast.error("انبار مقصد را انتخاب کنید")
        return
      }
      if (componentData.destinationStoreId === componentData.currentStoreId) {
        toast.error("انبار مبدا و مقصد نباید یکی باشد.")
        return
      }
      objectData.destinationStoreId = componentData.destinationStoreId
      objectData.destinationStoreName = componentData.destinationStoreName
    }


    let alreadyAdded = false;

    tableData = sendData?.tableData?.map(singleRow => {
      if (+singleRow.productId === +objectData.productId && +singleRow.storeId === +objectData.storeId) {
        singleRow.number = +singleRow.number + 1
        alreadyAdded = true
      }
      return singleRow
    }) || [];

    if (!alreadyAdded) {
      tableData.push({...objectData})
    }
    // i need  To Add a uniqId
    // const row = utilsFunction.addUniqId({...objectData})
    // tableData = [...sendData.tableData, row];
    tableData = calculateSumOfEachRow(tableData)
    setSendData({tableData})
    // i will calculate sumPrice  of them in effect of show table Component
  }
  const addProductHandler = () => {
    if (searchTerm === '') {
      const listType = select === 'barcode' ? 'بارکد' : select === 'internetId' ? 'کد کالای اینترنی' : 'نام کالا'
      toast.error(`لطفا یک  ${listType} وارد کنید.`)
      return
    }

    if (!componentData.currentStoreId) {
      toast.error(`لطفا یک  انبار انتخاب کنید.`)
      return
    }
    // همچنین باید اینجا چک کنم اگه از نوع نام بود رنگ و سایز باید پر شده باشه اگه پر نبود ارور میدم و برمیگردم
    if (select === 'name' && selectedColorSize === '') {
      toast.error(`انتخاب رنگ و سایز الزامی است..`)

      return;

    }


    _axios.get(url).then(res => {

      if (res.data.status) {
        addNewRowToPriceTable(res.data.data);
        // setComponentData({searchData: '', focusSearchData: true})
        setSearchTerm('')
        if (select === 'name') {
          setColorSizeArrayList([])
        }

        document.getElementById('focusSearchData').focus();
      } else {
        toast.error(res.data.message)
      }
    })
  }
  const handlePressEnter = (e) => {
    debugger
    if (e.key === "Enter") addProductHandler();
  }


  const selectedStore = (id, text) => {
    setComponentData({currentStoreId: id, currentStoreName: text})
  }

  return (<div className={"add__product__section row-select-box"}>
    {isShowStoreRoom !== false ? <SelectProductStoreRoom

      type={storeRoomType === undefined ? 'sell' : storeRoomType}
      selectedStore={selectedStore}
    /> : <></>}
    <div className={'solid-dyna-input'} style={{width:'240px'}}>
      <select
        className=""
        // onChange={(e) => setComponentData({listType: e.target.value})}
        onChange={e => {
          setSelect(e.target.value)
          setSearchTerm('')

        }}
        // value={componentData.listType}
        value={select}
        style={{marginLeft: 20, width: 230}}
      >
        <option value="internetId">بر اساس کد کالای اینترنتی</option>
        <option value="name">بر اساس نام کالا</option>
        <option value="barcode">بر اساس بارکد</option>
      </select>
    </div>


    {isLoading ? <>
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        {mode === 'remittance' && (!sendData.currentStoreId) && <div className={''}>یک انبار انتخاب کنید</div>}
        {(sendData.factorId === undefined || sendData.factorId === "") && (mode === 'saleReturn') ? <>یک فاکتور انتخاب
            کنید</> :
          <></>

        }

      </div>
      <div>&nbsp;</div>
    </> : <>
      <div style={{marginLeft: 10, width: 'max-content'}}>
        <div className={"solid-dyna-input"}>
          <input
            type="search"
            className="form-control"
            placeholder="جستجو"
            name="search"
            onKeyUp={handlePressEnter}
            list="factorPageProductList"
            autoComplete="off"
            // value={componentData.searchData}
            value={searchTerm}
            onChange={searchBoxChangeHandler}
            id={"focusSearchData"}
            autoFocus

          />
        </div>
        <datalist id="factorPageProductList">
          {searchListArray.map((value, index) => (<option key={index} value={value + ''}/>))}
        </datalist>
      </div>

      {select === 'name' && <div

        style={{marginLeft: 10}}>
        {isLoadingColorSize ? <> </> : <select
          className="form-select"
          required
          value={selectedColorSize}
          onChange={(e) => {
            setSelectedColorSize(e.target.value)
          }}
        >
          <option defaultValue hidden>
            انتخاب رنگ و سایز
          </option>
          {colorSizeArrayList.map((value) => <option value={value.color + "---" + value.size}>
            {value.color + " " + value.size}
          </option>)}
        </select>}
      </div>}

      <div className={"add-to-table"}>
        <button className={"add-to-table"} onClick={addProductHandler}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              fill="#fff"
              d="M15 10.625H5A.63.63 0 014.375 10 .63.63 0 015 9.375h10a.63.63 0 01.625.625.63.63 0 01-.625.625z"
            ></path>
            <path
              fill="#fff"
              d="M10 15.625A.63.63 0 019.375 15V5A.63.63 0 0110 4.375a.63.63 0 01.625.625v10a.63.63 0 01-.625.625z"
            ></path>
          </svg>
        </button>
      </div>

    </>}
  </div>);
};

export default AddProductSection;
